import React from 'react';
import Loader from 'react-loader-spinner';

/**
 * CustomLoader - Unified loading spinner component
 *
 * Usage:
 * - For tables: <CustomLoader /> (default, wraps in tr/td)
 * - For divs/general use: <CustomLoader inline /> (just the spinner)
 * - Custom message: <CustomLoader message="Fetching records..." />
 * - Custom size: <CustomLoader size="lg" /> (sm, md, lg)
 */
const CustomLoader = (props) => {
  const { inline, message, size, colSpan } = props;

  // Size presets
  const sizes = {
    sm: { width: 24, height: 24, fontSize: '11px', padding: '16px 0' },
    md: { width: 40, height: 40, fontSize: '12px', padding: '32px 0' },
    lg: { width: 56, height: 56, fontSize: '13px', padding: '48px 0' }
  };

  const currentSize = sizes[size] || sizes.md;

  const loaderContent = (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '12px',
      padding: inline ? '0' : currentSize.padding,
      width: '100%'
    }}>
      <div style={{
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <Loader
          type={props.type}
          color={props.color}
          height={currentSize.height}
          width={currentSize.width}
        />
      </div>
      {message !== false && (
        <span style={{
          fontSize: currentSize.fontSize,
          color: '#94A3B8',
          fontWeight: '500',
          letterSpacing: '0.01em'
        }}>
          {message || 'Loading...'}
        </span>
      )}
    </div>
  );

  // If inline mode, just return the loader content (for use in divs)
  if (inline) {
    return loaderContent;
  }

  // Default table mode - wrap in tr/td for use in tbody
  return (
    <tr>
      <td
        colSpan={colSpan || 60}
        style={{
          textAlign: 'center',
          border: 'none',
          background: 'transparent'
        }}
      >
        {loaderContent}
      </td>
    </tr>
  );
};

export default CustomLoader;

CustomLoader.defaultProps = {
  width: 40,
  height: 40,
  color: '#6366F1',
  type: 'Oval',
  inline: false,
  message: 'Loading...',
  size: 'md',
  colSpan: 60
};
